import { AssetDescription } from '@play-co/timestep-core';
import { BlockId } from '../../defs/block';
import { BlockEntity, spawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { blockViewAssets } from '../../util/blockTools';
import { IEffect } from './IEffect';

// types
//-----------------------------------------------------------------------------
export type HazardEffectOptions = {
  subject: BlockEntity;
};

// constants
//-----------------------------------------------------------------------------
const spawnId: BlockId = 'virus';

/*
    hazard generates a virus block
*/
export class HazardEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _options: HazardEffectOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: HazardEffectOptions) {
    this._scene = scene;
    this._options = options;
  }

  public static assets(): (string | AssetDescription<any>)[] {
    return blockViewAssets(spawnId);
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // spawn virus block
    await this._spawnVirusBlock();
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _spawnVirusBlock() {
    // spawn fire block
    spawnBlockEntity(
      this._scene,
      { id: spawnId },
      this._options.subject.c.position.mapPosition,
    );
  }
}
